// extracted by mini-css-extract-plugin
module.exports = {"trendsWrapper":"styles_trendsWrapper__1gQyD","trendsTitle":"styles_trendsTitle__1BDHa","trends":"styles_trends__3VGpN"};